import { FeatureStack } from "@/presentation/components/roadmaps/feature-stack";
import { VerdictColumn } from "@/presentation/components/roadmaps/verdict-column";
import { verdictsForBranch, type RoadmapBranch } from "@/presentation/data/roadmaps";
import type { BranchBoardPage } from "@/presentation/hooks/use-branch-board-page";

interface BranchBoardProps {
  branch: RoadmapBranch;
  page: BranchBoardPage;
}

export function BranchBoard({ branch, page }: BranchBoardProps) {
  const verdicts = verdictsForBranch(branch);
  return (
    <div
      data-slot="branch-board"
      className="flex h-[calc(100vh-12rem)] min-h-[560px] overflow-hidden rounded-xl border border-[oklch(0.91_0.008_240)] bg-white"
    >
      <FeatureStack
        features={page.stackFeatures}
        isLoading={page.isLoading}
        onDragStart={page.handleDragStart}
        onInfo={page.openInfo}
        onCreate={page.openCreate}
      />
      <div className="flex flex-1 gap-3 overflow-x-auto p-3">
        {verdicts.map((verdict) => (
          <VerdictColumn
            key={verdict}
            verdict={verdict}
            features={page.featuresByVerdict.get(verdict) ?? []}
            isOver={page.overVerdict === verdict}
            isLoading={page.isLoading}
            onDragOver={page.handleDragOver}
            onDragLeave={page.handleDragLeave}
            onDrop={page.handleDrop}
            onCardDragStart={page.handleDragStart}
            onInfo={page.openInfo}
            onEdit={page.openEdit}
            onRemove={page.removeFromBoard}
          />
        ))}
      </div>
    </div>
  );
}
